import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CustomValidators } from 'src/validators';
import * as moment from 'moment';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ViaCepService } from 'src/services/via-cep.service';

declare var google: any;

@Component({
  selector: 'app-new-interview',
  templateUrl: './new-interview.component.html',
  styleUrls: ['./new-interview.component.scss']
})
export class NewInterviewComponent implements OnInit {

  formInterview: FormGroup;
  currentProcessList: any;
  submiting: boolean = false;
  processList: Array<any> = [];
  private currentUser: any;
  edit: boolean = false;
  isEditMode$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @ViewChild('autocomplete', { static: false }) autocompleteInput!: ElementRef;

  constructor(
    fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<NewInterviewComponent>,
    private viaCep: ViaCepService
  ) {

    this.formInterview = fb.group({
      id: [null],
      processList: [null, Validators.required],
      name: [null, Validators.required],
      dateStart: [null, [Validators.required, CustomValidators.minDate(moment(), 'YYYY-MM-DD')]],
      timeStart: [null, [Validators.required, CustomValidators.beforeDate('timeEnd', 'HH:mm'), CustomValidators.date('HH:mm')]],
      timeEnd: [null, [Validators.required, CustomValidators.afterDate('timeStart', 'HH:mm'), CustomValidators.date('HH:mm')]],
      nextDays: [true, Validators.required],
      contact: [null, Validators.required],
      zipCode: [null, Validators.required],
      number: [null, Validators.required],
      address: [null, Validators.required],
      type: [false, Validators.required],
      candidatesSessionDuration: [null, Validators.required]
    });

    this.getProcesses(); // Carregar a lista de processos

    if (data){
      
      this.edit = true;
      this.toggleEditMode(true);
      
      const address = data.address;
      
      // Extrair o número (após a vírgula logo após o logradouro)
      const numberMatch = address.match(/,\s*(\d+)\s*-/);
      const number = numberMatch ? numberMatch[1] : null;

      // Extrair o CEP (padrão brasileiro: 5 dígitos + hífen + 3 dígitos)
      const cepMatch = address.match(/(\d{5}-?\d{3})/);
      const cep = cepMatch ? cepMatch[1] : null;
      

      this.formInterview.patchValue({
        id: data.id,
        processList: data.processListId,
        name: data.name,
        dateStart: data.dateStart,
        timeStart: data.timeStart,
        timeEnd: data.timeEnd,
        nextDays: data.nextDays ? true : false,
        contact: data.contact,
        address: data.address,
        zipCode: cep,
        number: number,
        candidatesSessionDuration: data.candidatesSessionDuration,
        type: data.type,
      });
      //this.initAutocomplete();
      //this.formInterview.markAsPristine();
    }else{
      //this.initAutocomplete();
    }

  }

  ngOnInit(): void {
    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;
        if (scope.indexOf('process_list:interview') > -1)
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject)

    this.isEditMode$.subscribe(isEditMode => {
      if (isEditMode) {
        // Remova validações no modo edição
        this.formInterview.get('dateStart')?.setValidators(null);
        this.formInterview.get('dateStart')?.setValidators([
          Validators.required
        ]);
      } else {
        // Adicione validações no modo criação
        this.formInterview.get('dateStart')?.setValidators([
          Validators.required,
          CustomValidators.minDate(moment(), 'YYYY-MM-DD')
        ]);
      }
      this.formInterview.get('dateStart')?.updateValueAndValidity();
    })

    this.formInterview.get('zipCode')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        cep => {
          if (!this.formInterview.get('zipCode').invalid) {
            this.viaCep.getLocation(cep)
              .subscribe(
                data => {
                  const type = this.formInterview.get('type')?.value;
                  if (type === true) return;

                  if (data && !data.erro) {
                    const { bairro, localidade, logradouro, uf } = data;
                    const number = this.formInterview.get('number')?.value || '';
                    const fullAddress = `${logradouro}, ${number} - ${bairro}, ${localidade} - ${uf}, ${cep}, Brasil`;

                    this.formInterview.patchValue({
                      address: fullAddress,
                    })

                  } else {
                    alert('CEP inválido por favor tente novamente');
                    this.formInterview.patchValue({
                      zipCode: ''
                    });
                  }
                }
              )
          }
        }
      )

  }

  public submitInterview() {
      
    const data = this.formInterview.getRawValue();
    const hours = moment(data.candidatesSessionDuration, 'HH:mm').hour();
    const minutes = moment(data.candidatesSessionDuration, 'HH:mm').minutes();
    data.candidatesSessionDuration = hours * 60 + minutes;

    const isValid = !this.formInterview.invalid;

    if (isValid) {
      
      const request$ = data.id
        ? this.http.save('process_list:interview_update', data)
        : this.http.save('process_list:interview', data);

      request$.subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            if(data.id){
              this.snackbar.open('Atualizado com Sucesso', 'OK', { duration: 3000 });
            }else{
              this.snackbar.open('Salvo com Sucesso', 'OK', { duration: 3000 });
            }
            
            this.dialogRef.close(result.type);
            // this.formInterview.reset({ processList: this.processListId });
          }
        },
        err => this.errorReport.showMessage(err)
      )

    }

  }

  getProcesses() {
    
    this.currentUser = JSON.parse(localStorage.getItem('token'));

    const params = {
      companyId: this.currentUser.company_id
    };

    this.http.list('process_list:list', params).subscribe(
      (result: any) => {
        this.processList = result.data;  
      },
      err => this.errorReport.showMessage(err)
    );
    
  }

  toggleEditMode(isEdit: boolean) {
    this.isEditMode$.next(isEdit);
  }

  onToggleChange(event: any): void {
    const isRemote = event.checked; // true para Remoto, false para Presencial

    if (isRemote) {
      // Ocultar campo e remover validação
      this.formInterview.get('address')?.clearValidators();
      this.formInterview.get('zipCode')?.clearValidators();
      this.formInterview.get('number')?.clearValidators();
    } else {
      // Mostrar campo e adicionar validação
      this.formInterview.get('address')?.addValidators(Validators.required);
      this.formInterview.get('zipCode')?.addValidators(Validators.required);
      this.formInterview.get('number')?.addValidators(Validators.required);
    }

    // Atualizar o estado do campo no formulário
    this.formInterview.get('address')?.updateValueAndValidity();
    this.formInterview.get('zipCode')?.updateValueAndValidity();
    this.formInterview.get('number')?.updateValueAndValidity();
    
  }

  // initAutocomplete() {
  //   setTimeout(() => {
      
  //     if (this.autocompleteInput?.nativeElement) {
  //       const autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput.nativeElement, {
  //         types: ['geocode'], // Apenas endereços
  //         componentRestrictions: { country: 'BR' } // Restrito ao Brasil
  //       });

  //       autocomplete.addListener('place_changed', () => {
  //         const place = autocomplete.getPlace();
  
  //         if (place.formatted_address) {
  //           this.formInterview.get('address').setValue(place.formatted_address);
  //           //console.log('Endereço selecionado:', place.formatted_address);
  //         } else {
  //           console.warn('Endereço não encontrado!');
  //         }
  //       });

  //     } else {
  //       console.warn("Campo de endereço não está visível ainda!");
  //     }
  //   }, 500); // Aguarda um pequeno tempo para garantir a renderização
  // }

}
